import * as React from 'react';

import FormControlWrapper from 'kiini/FormControlWrapper';
import ArgumentValueSelect from '../widgets/ArgumentValueSelect';

import {VAR_ID} from "../constEventHandlers"


const SelectGeoTriggerWidget = ({ instance, store, path, label }) => {

    const selectOptions = store.experience.geoTriggers.filter(geoTrigger => (geoTrigger.contentObjectLinkId == null)).map(geoTrigger => { 
        return {value: geoTrigger.id, label: geoTrigger.name };
    });


    return <FormControlWrapper label={label} showError={false}>
        <ArgumentValueSelect
            instance={instance}
            fieldName="values"
            argumentName={VAR_ID}
            selectOptions={selectOptions} />
    </FormControlWrapper>

}

export default SelectGeoTriggerWidget;